module.exports = __webpack_public_path__ + "page13two-11b1cd78bb96f914f334c05afaa2a3f2.png";